import { render, staticRenderFns } from "./LastViewedImageCarousel.vue?vue&type=template&id=1b1485ae&"
import script from "./LastViewedImageCarousel.vue?vue&type=script&lang=js&"
export * from "./LastViewedImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1485ae')) {
      api.createRecord('1b1485ae', component.options)
    } else {
      api.reload('1b1485ae', component.options)
    }
    module.hot.accept("./LastViewedImageCarousel.vue?vue&type=template&id=1b1485ae&", function () {
      api.rerender('1b1485ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29AmwmLeGSzka/JS/comp/LastViewedImageCarousel.vue"
export default component.exports